// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LHXVn","question":"styles_question___wmbl","description":"styles_description__3owEs"};